class Snackbar {

  static LENGTH_LONG = 10;

}


export default new Snackbar();
